// extracted by mini-css-extract-plugin
export default {"miniCalendarToggler":"usage-guide_miniCalendarToggler__KkQqp","title":"usage-guide_title__GUS1V"};